import { pathToRegexp } from 'path-to-regexp';
function isIndexRoute(route) {
    return route.index === true;
}
function isWildcardRoute(route) {
    return route.path === '*';
}
export function getRoutePath(route) {
    if (isIndexRoute(route)) {
        return { path: '', exact: true };
    }
    if (route.path === '*') {
        return { path: '', exact: false };
    }
    return { path: route.path, exact: !!route.exact };
}
export function matchPath(
/** What location the route is matched against */
comparePath, 
/** Route to test for a match */
route) {
    if (!comparePath.startsWith('/')) {
        comparePath = `/${comparePath}`;
    }
    const keys = [];
    const { path, exact } = getRoutePath(route);
    const re = pathToRegexp(path.startsWith('/') ? path : path.length ? `/${path}` : path, keys, { end: !!exact });
    const match = re.exec(comparePath);
    if (!match) {
        return null;
    }
    const params = keys.reduce((params, key, index) => {
        params[key.name] = match[index + 1];
        return params;
    }, {});
    let remainingPath;
    // special case: don't consume if match is '/'
    // FIXME: this probably means the logic around this is not as
    // straightforward as it should be.
    if (match[0] === '/') {
        remainingPath = comparePath;
    }
    else {
        remainingPath = comparePath.slice(match[0].length);
    }
    return {
        path: isWildcardRoute(route) ? comparePath : match[0],
        params,
        route,
        remainingPath: isWildcardRoute(route) ? '' : remainingPath,
    };
}
export function getBestRouteMatch(fullPath, routes) {
    for (const route of routes) {
        const match = matchPath(fullPath, route);
        if (match) {
            return match;
        }
    }
    return null;
}
export function getAllMatchingRoutes(fullPath, routes) {
    const match = getBestRouteMatch(fullPath, routes);
    if (!match) {
        return [];
    }
    const childRoutes = match.route.children;
    if (!childRoutes) {
        return [match];
    }
    return [match].concat(getAllMatchingRoutes(match.remainingPath, childRoutes));
}
//# sourceMappingURL=resolution.js.map